const DiaryResultsList = ({ calorieTarget, calories }) => {
    const results = [
        {
            key: 'energy',
            icon: '/assets/images/diary-icons/fire.svg',
            label: 'Energibehov',
            value: `${Math.round(calorieTarget)} kcal`,
            editLink: '/min-sida/installningar'
        },
        {
            key: 'food',
            icon: '/assets/images/diary-icons/utensils.svg',
            label: 'Mat',
            value: calories.food > 0 ? `${Math.round(calories.food)} kcal` : '-',
            editLink: false
        },
        {
            key: 'exercise',
            icon: '/assets/images/diary-icons/person-running.svg',
            label: 'Motion',
            value: calories.exercise > 0 ? `${Math.round(calories.exercise)} kcal` : '-',
            editLink: false
        }
    ];

    return (
        <ul>
            {results.map(({ key, icon, label, value, editLink }) => (
                <li key={key} className={`result-${key}`}>
                    <img src={icon} alt="" />
                    <div className="result-content">
                        <div className="result-content-inner">
                            <span className="bold-title">{label}</span>
                            <span>{value}</span>
                        </div>

                        {editLink && (
                            <a className="change-setting" href={editLink}>
                                Ändra inställningar
                            </a>
                        )}
                    </div>
                </li>
            ))}
        </ul>
    );
};

export default DiaryResultsList;
